<template>
  <div v-if="document?.file_url" class="document-preview">
    <iframe v-if="isPdf" :src="document.file_url" class="document-frame" title="Документ"/>
    <img v-else-if="isImage" :src="document.file_url" :alt="document.file_name" class="document-image">
    <div v-else class="document-fallback">
      <a :href="document.file_url" target="_blank" rel="noopener noreferrer" class="btn btn-outline-primary">
        Скачать {{ document.file_name || 'документ' }}
      </a>
    </div>
    <div class="mt-2">
      <a :href="document.file_url" target="_blank" rel="noopener noreferrer">
        {{ document.file_name || 'Скачать' }}
      </a>
    </div>
  </div>
  <div v-else class="text-muted">Документ не загружен</div>
</template>

<script>
export default {
  name: "DocumentPreview",
  props: {
    document: {
      type: Object,
      default: null,
    },
  },
  computed: {
    mimeType() {
      return this.document?.mime_type || ''
    },
    fileName() {
      return (this.document?.file_name || '').toLowerCase()
    },
    isPdf() {
      return this.mimeType === 'application/pdf' || this.fileName.endsWith('.pdf')
    },
    isImage() {
      return this.mimeType.startsWith('image/') || /\.(jpe?g|png)$/.test(this.fileName)
    },
  },
}
</script>

<style scoped>
.document-frame {
  width: 100%;
  min-height: 500px;
  border: 1px solid #d9dee3;
  border-radius: 4px;
}

.document-image {
  max-width: 100%;
  border: 1px solid #d9dee3;
  border-radius: 4px;
}
</style>
